import React from "react";

const SmallShape = ({ color = "#fff" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="154.51"
            height="360"
            viewBox="0 0 154.51 360"
        >
            <path
                id="Differenzmenge_153"
                data-name="Differenzmenge 153"
                d="M149.862,360H0V0H154.51a50.714,50.714,0,0,0-40.748,21.136L25.289,144.353A76.125,76.125,0,0,0,11,188.746L11,334.63A25.338,25.338,0,0,0,36.356,360l113.506,0Z"
                fill={color}
            />
        </svg>
    );
};

export default SmallShape;
